import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue"
import _imports_0 from '../../assets/login/Group 13.webp'
import _imports_1 from '../../assets/login/TuTu English.webp'
import _imports_2 from '../../assets/login/image 6.webp'
import _imports_3 from '../../assets/login/loginbtn.webp'
import _imports_4 from '../../assets/login/regbtn.webp'
import _imports_5 from '../../assets/login/image 7.webp'


const _hoisted_1 = { class: "logon" }
const _hoisted_2 = { class: "FloatingWindow" }
const _hoisted_3 = { class: "loginbox" }
const _hoisted_4 = { class: "login_content formbox" }
const _hoisted_5 = { class: "form-item-custom" }
const _hoisted_6 = {
  key: 0,
  class: "error-message"
}
const _hoisted_7 = { class: "form-item-custom" }
const _hoisted_8 = {
  key: 0,
  class: "error-message"
}
const _hoisted_9 = { class: "img_btn" }
const _hoisted_10 = { class: "reg_content formbox" }
const _hoisted_11 = { class: "form-item-custom" }
const _hoisted_12 = {
  key: 0,
  class: "error-message"
}
const _hoisted_13 = { class: "form-item-custom" }
const _hoisted_14 = {
  key: 0,
  class: "error-message"
}
const _hoisted_15 = { class: "form-item-custom" }
const _hoisted_16 = {
  key: 0,
  class: "error-message"
}
const _hoisted_17 = { class: "img_btn" }

import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus'
import { md5 } from 'js-md5';
import { getDeviceId } from '@/utils/getID'
//登录及注册接口引入
import { fnLogin, fnRegister } from '@/api/login'
import { setUserInfo } from '@/utils/userinfo'


export default /*@__PURE__*/_defineComponent({
  __name: 'LogonView',
  setup(__props) {

const router = useRouter()

const fingerprint = ref<any>('')

const LoginOrReg = ref<boolean>(true);

function setfnRegister(data: object) {
  fnRegister(data)
    .then((val) => {
      if (val) {
        LoginOrReg.value = !LoginOrReg.value
      }
    })
}

function setfnLogin(data: object) {
  fnLogin(data)
    .then((val: any) => {
      if (val) {
        setUserInfo(val.data.userinfo)
        router.push('/')
      }
    })
}

// 登录表单数据
const loginForm = reactive({
  mobile: '',
  password: ''
});

// 注册表单数据
const registerForm = reactive({
  mobile: '',
  password: '',
  confirmPassword: ''
});

// 验证错误信息
const loginErrors = reactive({
  mobile: '',
  password: ''
});

const registerErrors = reactive({
  mobile: '',
  password: '',
  confirmPassword: ''
});

// 正则验证规则
const validationRules = {
  mobile: {
    pattern: /^1[3-9]\d{9}$/,
    message: '请输入正确的11位手机号'
  },
  password: {
    pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]{6,30}$/,
    message: '密码只能包含英文数字，长度为6-30位'
  }
}

// 验证单个字段 - 登录表单
function validateLoginField(field: keyof typeof loginForm) {
  const value = loginForm[field]
  const rule = validationRules[field]

  if (!value.trim()) {
    loginErrors[field] = field === 'mobile' ? '请输入手机号' : '请输入密码'
    return false
  }

  if (!rule.pattern.test(value)) {
    loginErrors[field] = rule.message
    return false
  }

  loginErrors[field] = ''
  return true
}

// 验证单个字段 - 注册表单
function validateRegisterField(field: keyof typeof registerForm) {
  const value = registerForm[field]

  if (!value.trim()) {
    if (field === 'mobile') {
      registerErrors[field] = '请输入手机号'
    } else if (field === 'password') {
      registerErrors[field] = '请输入密码'
    } else {
      registerErrors[field] = '请再次输入密码'
    }
    return false
  }

  if (field === 'mobile') {
    if (!validationRules.mobile.pattern.test(value)) {
      registerErrors[field] = validationRules.mobile.message
      return false
    }
  } else if (field === 'password') {
    if (!validationRules.password.pattern.test(value)) {
      registerErrors[field] = validationRules.password.message
      return false
    }
  } else if (field === 'confirmPassword') {
    if (!validationRules.password.pattern.test(value)) {
      registerErrors[field] = validationRules.password.message
      return false
    }
    if (value !== registerForm.password) {
      registerErrors[field] = '两次输入的密码不一致'
      return false
    }
  }

  registerErrors[field] = ''
  return true
}

// 验证所有字段 - 登录表单
function validateAllLoginFields() {
  let isValid = true
  Object.keys(loginForm).forEach(field => {
    if (!validateLoginField(field as keyof typeof loginForm)) {
      isValid = false
    }
  })
  return isValid
}

// 验证所有字段 - 注册表单
function validateAllRegisterFields() {
  let isValid = true
  Object.keys(registerForm).forEach(field => {
    if (!validateRegisterField(field as keyof typeof registerForm)) {
      isValid = false
    }
  })
  return isValid
}

function clearIpt() {
  // 清空登录表单
  loginForm.mobile = '';
  loginForm.password = '';

  // 清空注册表单
  registerForm.mobile = '';
  registerForm.password = '';
  registerForm.confirmPassword = '';

  // 清除验证错误信息
  loginErrors.mobile = '';
  loginErrors.password = '';
  registerErrors.mobile = '';
  registerErrors.password = '';
  registerErrors.confirmPassword = '';
}

async function loginIn() {
  if (validateAllLoginFields()) {
    // 确保设备ID已获取
    if (!fingerprint.value) {
      fingerprint.value = await getDeviceId()
    }
    const registerData = {
      mobile: loginForm.mobile,
      password: md5(loginForm.password),
      userEquipmentKey: fingerprint.value
    };

    setfnLogin(registerData)
  } else {
    ElMessage.error('请检查输入信息');
  }
}

function register() {
  if (validateAllRegisterFields()) {
    // 提取注册数据，去掉confirmPassword字段
    const registerData = {
      mobile: registerForm.mobile,
      password: md5(registerForm.password)
    };
    setfnRegister(registerData)

    // 这里可以添加注册逻辑
  } else {
    ElMessage.error('请检查输入信息');
  }
}

onMounted(async () => {
  fingerprint.value = await getDeviceId()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _cache[14] || (_cache[14] = _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: "bg_img"
          }, null, -1)),
          _cache[15] || (_cache[15] = _createElementVNode("img", {
            src: _imports_1,
            alt: "",
            class: "img_tutu"
          }, null, -1)),
          _cache[16] || (_cache[16] = _createElementVNode("img", {
            src: _imports_2,
            alt: "",
            class: "img_star"
          }, null, -1)),
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(["iptBox", { 'error': loginErrors.mobile }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Phone number",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginForm.mobile) = $event)),
                    onBlur: _cache[1] || (_cache[1] = ($event: any) => (validateLoginField('mobile')))
                  }, null, 544), [
                    [_vModelText, loginForm.mobile]
                  ])
                ], 2),
                (loginErrors.mobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(loginErrors.mobile), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["iptBox", { 'error': loginErrors.password }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    placeholder: "Please enter your password",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((loginForm.password) = $event)),
                    onBlur: _cache[3] || (_cache[3] = ($event: any) => (validateLoginField('password')))
                  }, null, 544), [
                    [_vModelText, loginForm.password]
                  ])
                ], 2),
                (loginErrors.password)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(loginErrors.password), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: _imports_3,
                  alt: "",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (loginIn()))
                })
              ])
            ]),
            _createElementVNode("p", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (LoginOrReg.value = !LoginOrReg.value, clearIpt()))
            }, "Register")
          ], 512), [
            [_vShow, LoginOrReg.value]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: _normalizeClass(["iptBox", { 'error': registerErrors.mobile }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Phone number",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((registerForm.mobile) = $event)),
                    onBlur: _cache[7] || (_cache[7] = ($event: any) => (validateRegisterField('mobile')))
                  }, null, 544), [
                    [_vModelText, registerForm.mobile]
                  ])
                ], 2),
                (registerErrors.mobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(registerErrors.mobile), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", {
                  class: _normalizeClass(["iptBox", { 'error': registerErrors.password }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    placeholder: "Please enter your password",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((registerForm.password) = $event)),
                    onBlur: _cache[9] || (_cache[9] = ($event: any) => (validateRegisterField('password')))
                  }, null, 544), [
                    [_vModelText, registerForm.password]
                  ])
                ], 2),
                (registerErrors.password)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(registerErrors.password), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: _normalizeClass(["iptBox", { 'error': registerErrors.confirmPassword }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    placeholder: "Please confirm your password",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((registerForm.confirmPassword) = $event)),
                    onBlur: _cache[11] || (_cache[11] = ($event: any) => (validateRegisterField('confirmPassword')))
                  }, null, 544), [
                    [_vModelText, registerForm.confirmPassword]
                  ])
                ], 2),
                (registerErrors.confirmPassword)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(registerErrors.confirmPassword), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("img", {
                  src: _imports_4,
                  alt: "",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (register()))
                })
              ])
            ]),
            _createElementVNode("p", {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (LoginOrReg.value = !LoginOrReg.value, clearIpt()))
            }, "Log in")
          ], 512), [
            [_vShow, !LoginOrReg.value]
          ])
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("img", {
          src: _imports_5,
          alt: "",
          class: "img_balloon"
        }, null, -1))
      ])
    ])
  ]))
}
}

})